import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { EnumConfigActions, GetConfig, GetConfigSuccess } from './config.action';
import { ConfigInterface } from './config.interface';
import { ConfigService } from './config.service';

@Injectable()
export class ConfigEffects {
  getConfig$ = createEffect(() => this.actions$.pipe(
    ofType<GetConfig>(EnumConfigActions.GetConfig),
    switchMap(() => {
      // Note : For new settings static we doesn't need to load config file, already load into environment.ts
      if (window['NAConfig'] && !window['NAConfig'].isProdDomain) {
        return this.configService.loadConfig();
      }
      return of(window['NAConfig']);
    }),
    map((config: ConfigInterface) => new GetConfigSuccess(config))
  ));

  constructor(
    private configService: ConfigService,
    private actions$: Actions
  ) { }
}
